import React, { Suspense } from "react";

import classNames from "classnames";

import Loading from "components/Loading";

const LazyDiffViewUnified = React.lazy(() => import("./index.lazy"));

const DiffViewUnified = ({
  original,
  modified,
  className,
}: {
  original: string;
  modified: string;
  className?: string;
}) => {
  return (
    <Suspense fallback={<Loading />}>
      <LazyDiffViewUnified
        original={original}
        modified={modified}
        className={classNames(
          "rounded border border-[#E8E8EE] text-[#606060] font-query text-[13px]",
          className,
        )}
      />
    </Suspense>
  );
};

export default DiffViewUnified;
